import { provenanceTooltip } from './provenance';

const COLUMN_TITLES = {
  time: 'Time',
  email: 'Email',
  tool: 'Tool',
  source: 'Source',
  vintage: 'Vintage',
  prompt: 'Prompt',
  args: 'Args',
};

function fullTime(createdAt) {
  const date = new Date(createdAt);
  if (!createdAt || Number.isNaN(date.getTime())) return '—';
  return `${date.toLocaleString()}\n${date.toISOString()}`;
}

function fullArgs(args) {
  if (args === undefined || args === null) return '—';
  if (typeof args === 'object' && Object.keys(args).length === 0) return '—';
  return typeof args === 'string' ? args : JSON.stringify(args, null, 2);
}

/**
 * The complete, untruncated value behind one cell of the MCP Usage Activity
 * table, for the click-to-read dialog.
 * @returns {{title: string, text: string, monospace: boolean}}
 */
export function getCellDetail(log, column) {
  const safe = log || {};
  const title = COLUMN_TITLES[column] || column;
  switch (column) {
    case 'time':
      return { title, text: fullTime(safe.createdAt), monospace: false };
    case 'email':
      return { title, text: safe.email || '—', monospace: false };
    case 'tool':
      return { title, text: safe.toolName || '—', monospace: true };
    case 'source':
      return {
        title,
        text: `${safe.dataSource || '—'}\n\n${provenanceTooltip(safe)}`,
        monospace: false,
      };
    case 'vintage':
      return {
        title,
        text: `${safe.dataVintage || '—'}\n\n${provenanceTooltip(safe)}`,
        monospace: false,
      };
    case 'prompt':
      return { title, text: safe.prompt || '—', monospace: false };
    case 'args':
      return { title, text: fullArgs(safe.args), monospace: true };
    default:
      return { title, text: '—', monospace: false };
  }
}
